import { COMPLETED_STATUS, DEFAULT_SUPPLEMENTAL_ITEMS_PATH } from './constants'
import { getNested } from './utils'

const DEFAULT_FIELDS = {
  label: 'taskName',
  status: 'completedStatus',
  type: 'taskType',
  isInternal: 'isInternal'
}

/**
 * Resolve a display field value from an item using displayConfig field mapping.
 */
export function getField (item, displayConfig, key) {
  const fieldMap = displayConfig?.fields ?? {}
  const accessor = fieldMap[key] ?? DEFAULT_FIELDS[key]
  return accessor ? getNested(item, accessor) : null
}

/**
 * Get the items array from source data using displayConfig.itemsPath.
 */
export function getItems (data, displayConfig) {
  const path = displayConfig?.itemsPath ?? DEFAULT_SUPPLEMENTAL_ITEMS_PATH
  if (!path || !data) return []
  const value = getNested(data, path)
  return Array.isArray(value) ? value : []
}

/**
 * Return the status value that should be treated as "complete" (strikethrough + success color).
 * Falls back to {@link COMPLETED_STATUS} when displayConfig doesn't specify one.
 */
export function getCompletedValue (displayConfig) {
  return displayConfig?.completedValue ?? COMPLETED_STATUS
}

/**
 * Resolve detail fields for a single pipeline item.
 * @param {object} item - pipeline row
 * @param {Array<{field:string, label?:string, format?:string}>} detailFields
 * @param {function} formatter - formatter from useFormattingContext
 * @returns {Array<{label:string, value:*, format:string|undefined}>}
 */
export function resolveDetailFields (item, detailFields, formatter) {
  if (!Array.isArray(detailFields) || !detailFields.length || !item) return []
  return detailFields.reduce((acc, df) => {
    const raw = getNested(item, df.field)
    if (raw == null || raw === '') return acc
    const value = df.format && formatter ? formatter(raw, df.format) : raw
    acc.push({ label: df.label || df.field, value, format: df.format })
    return acc
  }, [])
}
